<template>
  <woot-modal :show.sync="show" :on-close="onCancel">
    <div class="column content-box">
      <woot-modal-header
        :header-title="modalTitle"
        :header-content="modalDescription"
      />
      <form class="row" @submit.prevent="onSubmit">
        <div class="medium-12 columns">
          <label :class="{ error: $v.loseReason.$error }">
            {{ $t('TICKET.LOSE_MODAL.REASON.LABEL') }}
            <textarea
              v-model.trim="loseReason"
              rows="3"
              type="text"
              :placeholder="$t('TICKET.LOSE_MODAL.REASON.PLACEHOLDER')"
              @input="$v.loseReason.$touch"
            />
            <span v-if="$v.loseReason.$error" class="message">
              {{ $t('TICKET.LOSE_MODAL.REASON.ERROR') }}
            </span>
          </label>
        </div>

        <div class="medium-12 columns">
          <label>
            {{ $t('TICKET.LOSE_MODAL.COMMENT.LABEL') }}
            <textarea
              v-model.trim="loseComment"
              rows="3"
              type="text"
              :placeholder="$t('TICKET.LOSE_MODAL.COMMENT.PLACEHOLDER')"
            />
          </label>
        </div>

        <div class="modal-footer">
          <div class="medium-12 columns">
            <woot-submit-button
              :disabled="$v.loseReason.$invalid || isSubmitting"
              :button-text="submitButtonText"
              :loading="isSubmitting"
            />
            <button class="button clear" @click.prevent="onCancel">
              {{ $t('TICKET.LOSE_MODAL.CANCEL') }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </woot-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import alertMixin from 'shared/mixins/alertMixin';
import { mapGetters } from 'vuex';

export default {
  name: 'ModalLoseTicket',
  mixins: [alertMixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    ticket: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loseReason: '',
      loseComment: '',
      isSubmitting: false,
    };
  },
  validations: {
    loseReason: {
      required,
    },
  },
  computed: {
    ...mapGetters({
      kanbanList: 'getKanbanfunnels',
    }),

    isBusinessOpportunity() {
      if (!this.ticket?.kanbanfunnel_id) {
        return false;
      }
      const kanban = this.kanbanList.find(k => k.id === this.ticket.kanbanfunnel_id);
      return kanban && (kanban.type_opportunity === 'business' || kanban.type_opportunity === 'both');
    },

    modalTitle() {
      return this.isBusinessOpportunity 
        ? this.$t('TICKET.LOSE_MODAL.BUSINESS_TITLE') 
        : this.$t('TICKET.LOSE_MODAL.TITLE');
    },

    modalDescription() {
      return this.isBusinessOpportunity 
        ? this.$t('TICKET.LOSE_MODAL.BUSINESS_DESC') 
        : this.$t('TICKET.LOSE_MODAL.DESC');
    },

    submitButtonText() {
      return this.isBusinessOpportunity 
        ? this.$t('TICKET.LOSE_MODAL.BUSINESS_SUBMIT') 
        : this.$t('TICKET.LOSE_MODAL.SUBMIT');
    },
  },
  methods: {
    onCancel() {
      this.$emit('cancel');
      this.resetForm();
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.isSubmitting = true;
      try {
        const payload = {
          ...this.ticket,
          status: 'lose',
          status_reason: this.loseReason,
          status_comment: this.loseComment,
        };

        await this.$store.dispatch('updateTicket', payload);
        const message = this.isBusinessOpportunity 
          ? this.$t('TICKET.LOSE_MODAL.BUSINESS_SUCCESS') 
          : this.$t('TICKET.LOSE_MODAL.SUCCESS');
        this.showAlert(message);
        this.$emit('success');
        this.resetForm();
      } catch (error) {
        const message = this.isBusinessOpportunity 
          ? this.$t('TICKET.LOSE_MODAL.BUSINESS_ERROR') 
          : this.$t('TICKET.LOSE_MODAL.ERROR');
        this.showAlert(message);
      } finally {
        this.isSubmitting = false;
      }
    },
    resetForm() {
      this.loseReason = '';
      this.loseComment = '';
      this.$v.$reset();
    },
  },
};
</script>

<style scoped>
.content-box {
  padding: var(--space-normal);
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: var(--space-normal);
}
</style>
